import { Button, Container, Divider, Paper, Stack, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BSSLogo from '../assets/bss-logo.png';

const ContainerStyle = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const PaperStyle = styled(Paper)`
  min-width: 500px;
  padding: 32px;
`;

const VerticalStack = styled(Stack)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImageStyle = styled('img')`
  width: 100px;
  height: auto;
  object-fit: contain;
`;

const MainPage = () => {
  const navigate = useNavigate();

  const handleNewRegister = () => {
    navigate('/attention');
  };

  return (
    <ContainerStyle>
      <PaperStyle>
        <VerticalStack>
          <ImageStyle src={BSSLogo} alt="bss-logo" />
          <Typography variant="h6" sx={{ color: 'surface.700', mt: 1 }}>
            Nasabah Korporasi
          </Typography>
          <Divider sx={{ width: '100%', mt: 3 }} />
          <Typography variant="h5" sx={{ fontWeight: 600, py: 3 }}>
            Sudah memiliki rekening?
          </Typography>
          <Stack direction="row" spacing={3} width="100%">
            <Button
              variant="outlined"
              sx={{ width: '100%' }}
              onClick={() => window.open('https://ibank.banksampoerna.co.id/ibb/')}
            >
              Akses rekening saya
            </Button>
            <Button variant="contained" sx={{ width: '100%' }} onClick={handleNewRegister}>
              Daftar baru
            </Button>
          </Stack>
        </VerticalStack>
      </PaperStyle>
    </ContainerStyle>
  );
};

export default MainPage;
